module.exports = __webpack_public_path__ + "d8b4ad35c1f84c8680a5a8e07ba5e077.png";